/**
 * CR-5314: Shared rule for whether the per-user "Send Invitation" control
 * (the User Details modal button and the User Management row icon) should be
 * shown for a given user.
 *
 * The User Management Status badge resolves to:
 *   - "Inactive"     when !is_active
 *   - "Invite Sent"  when is_active && invitation_sent && !has_joined
 *   - "Active"       otherwise (is_active && (has_joined || !invitation_sent))
 *
 * The ticket requires the per-user invitation action to be hidden for every
 * user shown as "Active" and available only for non-active users
 * (Invited / Pending). A user who has already joined the platform is never
 * re-invited regardless of badge. First invites for never-invited active
 * users go through the bulk "Select All Not Invited" flow, not this control.
 *
 * @param user - the nested auth user (e.g. UserProfile.user)
 * @returns true when the per-user Send Invitation control should be visible
 */
export function canSendInvitation(user: {
  is_active: boolean;
  invitation_sent?: boolean;
  has_joined?: boolean;
}): boolean {
  // A joined user has set up their account and must never be re-invited.
  if (user.has_joined) return false;
  // Shown only for users NOT displayed as "Active": inactive accounts, or
  // those with an invitation already sent but not yet accepted (resend).
  return !user.is_active || Boolean(user.invitation_sent);
}
